module.exports = __webpack_public_path__ + "img/Eventos.e9488ef9.png";